import { postJson } from '~/core/ajax-json.js';

const handlePaymentResultCallback = fingerPrintData => {
	const RETRY_STATE = 'PENDING_RESULT_AFTER_SINGLE_CALL';
	const successState = fingerPrintData.successful;
	const retryResponseState = fingerPrintData.sendHandlerData && fingerPrintData.sendHandlerData.actualSendHandler;
	const fingerPrintDataRetry = Boolean(retryResponseState === RETRY_STATE);
	let handleIsDone = false;

	if (fingerPrintDataRetry) {
		handleIsDone = false;
	} else if (successState) {
		handleIsDone = true;
	} else if (!successState) {
		handleIsDone = true;
	}

	return handleIsDone;
};

const pollPayment = (serverUrl, accHistRef, numberOfTimesToTry, waitTimeBetweenTriesMs, doneCallback) => {
	setTimeout(() => {
		postJson(serverUrl, {
			accHistRef,
			isMobileDevice: true
		}).then(data => {
			if (handlePaymentResultCallback(data)) {
				doneCallback(data);
				return;
			}
			// FIXME linting
			numberOfTimesToTry -= 1; // eslint-disable-line no-param-reassign
			if (numberOfTimesToTry > 0) {
				pollPayment(serverUrl, accHistRef, numberOfTimesToTry, waitTimeBetweenTriesMs, doneCallback);
			} else {
				doneCallback(data, true);
			}
		});
	}, waitTimeBetweenTriesMs);
};

const fetchfingerPrintData = p => {
	const serverUrl = p.paymentFetchResultFlow;
	const { doneCallback } = p;
	const DEFAULT_TOTAL_TIME_TO_WAIT_MS = 30000;
	const DEFAULT_WAIT_TIME_BEETWEEN_TRIES_MS = 3000;
	const numberOfTimesToTry = Math.floor(DEFAULT_TOTAL_TIME_TO_WAIT_MS / DEFAULT_WAIT_TIME_BEETWEEN_TRIES_MS);
	const waitTimeBetweenTriesMs = DEFAULT_WAIT_TIME_BEETWEEN_TRIES_MS;
	const accHistRef = p.accHistRef || null;

	pollPayment(serverUrl, accHistRef, numberOfTimesToTry, waitTimeBetweenTriesMs, doneCallback);
};

const sendThreeDSData = (data, doneCallback, onerror) => {
	postJson(data.postUrl, {
		...data,
		isMobileDevice: true
	})
		.then(response => {
			doneCallback(response);
		})
		.catch(e => {
			onerror(e);
		});
};

export { fetchfingerPrintData, sendThreeDSData };
